import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import { Row, Col } from '../components/Grid';
import Alert from '../components/Alert';
import Label from '../components/Label';
import BackButton from '../components/BackButton';
import Button from '../components/Button';
import FormError from '../components/FormError';
import Input from '../components/Input';
import Referrer from '../components/Referrer';
import Spinner from '../components/Spinner';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import ProtectCard from '../components/ProtectCard';
import { getButtonId, getParameters } from '../functions';
import { click_submit } from '../techspec';

import useStore from '../store';

import {
  getPickupInfo,
  submitForm,
  breakpoints,
  colors,
  actualizaSolicitudPlatinum,
  consultarSolicitudPlatinum,
} from '../config';
import useMatchMedia from '../useMatchMedia';
import LikertSlider from '../components/LikertSlider';

const Summary = props => {
  const [captcha, setCatpcha] = useState('');
  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const [{ selectedGroup, selectedCard, origen }, store, setStore] = useStore();
  const isMobile = useMatchMedia(`(max-width: ${breakpoints.md})`);

  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [urlData, setUrlData] = useState('');

  useEffect(() => {
    const parametros = getParameters();
    setUrlData({ step: '/summary', tipo: parametros?.tipo });
  }, []);

  let count = 0;

  const consultarEstadoSolicitudPlatinum = () => {
    consultarSolicitudPlatinum(Object.assign(state.data.solicitudId))
      .then(res => {
        // cada vez que devuelve 'EN_CURSO' debe hacer el llamado de nuevo esperando 5 segundos, hasta completar 1 minuto
        if (res.data == 'EN_CURSO') {
          setIsLoading(true);
          if (count <= 11) {
            count++;
            setTimeout(() => {
              consultarEstadoSolicitudPlatinum();
            }, 5000);
          } else {
            setIsLoading(false);

            if (props.platinum) {
              props.history.push('/10');
            } else {
              props.history.push('/success');
            }
          }
          // ----
        } else if (res.data == 'REQUIERE_DOCUMENTACION') {
          setIsLoading(false);
          props.history.push('/10');
        } else if (res.data == 'NO_REQUIERE_DOCUMENTACION' || res.data == 'ERROR_INTERNO') {
          setIsLoading(false);
          props.history.push('/success');
        } else if (res.data == 'RECHAZADO') {
          setIsLoading(false);
          props.history.push('/error');
        } else {
          setIsLoading(false);
          props.history.push('/error');
        }
      })
      .catch(err => {
        setHasError(true);
        setIsLoading(false);
      });
  };

  const onSubmit = data => {
    // process.env.REACT_APP_ENV !== 'production' && props.history.push('/success');
    // if (props.platinum) {
    action(data);
    setIsLoading(true);
    setHasError(false);

    click_submit();

    actualizaSolicitudPlatinum(
      Object.assign(state.data, { selectedGroup, selectedCard, origen }),
      captcha,
    )
      .then(response => {
        if (response && response.status === 200) {
          //devuelve un array de errores, si el length es 0 esta todo bien
          if (response.data.errores.string.length === 0) {
            consultarEstadoSolicitudPlatinum();
          } else {
            setHasError(true);
          }
        } else {
          setHasError(true);
        }

        //setIsLoading(false);
      })
      .catch(error => {
        setHasError(true);
        setIsLoading(false);
      });
    // } else {
    //   setIsLoading(true);
    //   setHasError(false);

    //   submitForm(Object.assign(state.data, { selectedGroup, selectedCard, origen }), captcha)
    //     .then(response => {
    //       if (response && response.status === 200) {
    //         if (response.data.errores.string.length === 0) {
    //           action({ solicitudId: response.data.codigoSolicitud });
    //           setIsLoading(false);
    //           props.history.push('/success');
    //         } else {
    //           setHasError(true);
    //         }
    //       } else {
    //         setHasError(true);
    //       }

    //       setIsLoading(false);
    //     })
    //     .catch(error => {
    //       setHasError(true);
    //       setIsLoading(false);
    //     });
    // }
  };

  const { name, phone, email, numero_cedula, department, localidad, address, pickup } =
    state?.data || {}; // NOTE: prevent fail
  const pickupInfo = getPickupInfo(pickup, state?.data?.zona);

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>
          {props.platinum
            ? 'Confirmá los datos ingresados.'
            : 'Para terminar, confirmá los datos ingresados.'}
        </Title>

        <Input label="Nombre completo" value={name} readOnly tabIndex={-1} />

        {isMobile ? (
          <>
            <Input label="Email" value={email} readOnly tabIndex={-1} />
            <Input label="Número de celular" value={phone} readOnly tabIndex={-1} />
          </>
        ) : (
          <Row gutter={false}>
            <Col size={8}>
              <Input label="Email" value={email} readOnly tabIndex={-1} />
            </Col>
            <Col size={4}>
              <Input label="Número de celular" value={phone} readOnly tabIndex={-1} />
            </Col>
          </Row>
        )}

        <Input label="Número de documento" value={numero_cedula} readOnly tabIndex={-1} />

        <Row gutter={false}>
          <Col>
            <Input label="Departamento" value={department} readOnly tabIndex={-1} />
          </Col>
          <Col>
            <Input label="Localidad" value={localidad} readOnly tabIndex={-1} />
          </Col>
        </Row>

        <Input label="Dirección" value={address} readOnly tabIndex={-1} />

        {state?.data?.delivery === 'Retiro' && pickupInfo && (
          <div className="option-details">
            <Label readOnly={true}>Retiro en</Label>

            <div className="option-details-title">{pickupInfo.title}</div>
            <div className="option-details-subtitle">{pickupInfo.address}</div>
            <div className="option-details-content">
              {pickupInfo.details.map((p, i) => (
                <p key={`p-${i}`}>{p}</p>
              ))}
            </div>
          </div>
        )}

        {state?.data?.delivery !== 'Retiro' && (
          <div className="option-details">
            <Label readOnly={true}>Recibe en</Label>
            {state?.data?.delivery === 'domicilio' ? (
              <div className="option-details-title">Domicilio</div>
            ) : null}
            <div className="option-details-subtitle">
              {state?.data?.delivery === 'domicilio'
                ? state?.data?.address
                : state?.data?.entrega_address}
            </div>
          </div>
        )}

        {state?.data?.hasReferred === 'yes' &&
          state?.data?.referrer_document_type &&
          state?.data?.referrer_document_number && (
            <Referrer
              documentNumber={state?.data?.referrer_document_number}
              documentType={state?.data?.referrer_document_type}
            />
          )}

        <ProtectCard />

        <div className="captcha-wrapper">
          <input
            type={process.env.REACT_APP_ENV === 'production' ? 'hidden' : 'text'}
            onChange={event =>
              process.env.REACT_APP_ENV !== 'production' && setCatpcha(event.target.value)
            }
            name="captcha"
            value={captcha}
            ref={register({ required: 'Este campo es obligatorio.' })}
            placeholder="Captcha…"
          />

          <ReCAPTCHA
            sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
            onChange={value => setCatpcha(value)}
          />

          {errors.captcha && <FormError>{errors.captcha.message}</FormError>}
        </div>
      </div>

      {hasError && <Alert />}

      <div className="form-actions">
        <Button
          block
          type="submit"
          disabled={isLoading}
          id={
            urlData && getButtonId(urlData?.tipo, '/summary')
              ? getButtonId(urlData?.tipo, '/summary')
              : props.location.state
              ? `next-button-step-9-${props.location.state}`
              : 'next-button-step-9'
          }
        >
          {isLoading ? <Spinner size={10} /> : props.platinum ? 'Siguiente' : 'Confirmar'}
        </Button>

        <BackButton disabled={isLoading} />
      </div>

      <style jsx>{`
        .captcha-wrapper {
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          margin-bottom: 30px;
          margin-top: 30px;
        }

        .captcha-wrapper input {
          padding: 10px;
          width: 100%;
          margin-bottom: 20px;
        }

        .option-details-title {
          font-size: 20px;
          margin-top: 10px;
        }

        .option-details-subtitle {
          font-size: 16px;
        }

        .option-details-content {
          color: ${colors.textMuted};
          font-size: 14px;
        }

        .option-details-content :global(p) {
          margin-bottom: 0;
          margin-top: 8px;
        }

        .option-details-content :global(> p + p) {
          margin-top: 0;
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Summary);
